import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

const fmtDate = (d) => new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

export default function News() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="news-page">
      <Seo
        title="News"
        path="/news"
        description="Latest news and announcements from Yayra Glover Organic Inputs — new products, certifications, projects and updates for Ghana's organic farming community."
      />
      <section className="bg-brand text-brand-bg noise-overlay">
        <div className="mx-auto max-w-4xl px-6 py-20 text-center">
          <span className="text-xs uppercase tracking-[0.28em] text-brand-ochre font-semibold">What's New</span>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl">News & Announcements</h1>
          <p className="mt-4 text-brand-bg/80 max-w-xl mx-auto">
            Company updates, new products, certifications and milestones from the field.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-6 py-16">
        {loading ? (
          <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-brand" /></div>
        ) : items.length === 0 ? (
          <p className="text-brand-muted py-16 text-center">No news yet. Check back soon.</p>
        ) : (
          <div className="space-y-6" data-testid="news-list">
            {items.map((n) => (
              <Link key={n.news_id} to={`/news/${n.slug}`} data-testid={`news-card-${n.slug}`}
                className="group flex flex-col sm:flex-row gap-5 bg-white border border-brand/10 rounded-sm overflow-hidden hover:shadow-lg transition-shadow">
                {n.cover_image && (
                  <div className="sm:w-56 shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden bg-brand-surface">
                    <img src={n.cover_image} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="p-5 sm:py-6 flex flex-col justify-center flex-1">
                  <p className="text-xs text-brand-muted uppercase tracking-wider">{fmtDate(n.created_at)}</p>
                  <h2 className="mt-1.5 font-display text-xl text-brand leading-snug group-hover:text-brand-hover transition-colors">{n.title}</h2>
                  <p className="mt-2 text-sm text-brand-muted leading-relaxed line-clamp-2">{n.excerpt}</p>
                  <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-brand-terracotta">
                    Read more <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
